export const coreAddresses = {
  balanceTracker: "0x9fb7215ef6297498D6807caf9f3aC8BA3154db29",
  eVaultFactory: "0x238bF86bb451ec3CA69BB855f91BDA001aB118b9",
  eVaultImplementation: "0x70f1286239228B28A047c727C2df390045299486",
  eulerEarnFactory: "0x3073e1B42f8Cc933f2d678DdA10acDE51F4E49a3",
  evc: "0x08739CBede6E28E387685ba20e6409bD16969Cde",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x6682Af2820633067A1de5bE99b2DCb2d38F1e241",
  sequenceRegistry: "0xC4589C6199516F96B422D91020563Fe65b28918e",
} as const
